export default __webpack_public_path__ + "static/media/640_business06-nl-web.634d155a.png";